import { platformApi } from '@/apis';
import ir3Logo from '@/svg/ir3Logo.svg';
import { notify, reviveDate } from '@/utils';
import { captureMessage } from '@sentry/react';
import { useQueryClient } from '@tanstack/react-query';
import { parseServerSentEvents } from 'parse-sse';
import { useEffect } from 'react';

export function useNotificationStream() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const ctrl = new AbortController();

    async function initiateStream() {
      try {
        const response = await platformApi.get('sse/user-notifications', {
          signal: ctrl.signal,
        });

        for await (const msg of parseServerSentEvents(response)) {
          captureMessage('Received notification', {
            level: 'debug',
            extra: { msg },
          });

          if (msg.event === 'insert') {
            const notification = JSON.parse(msg.data, reviveDate);

            notify(notification.title, {
              body: notification.message,
              icon: ir3Logo,
              timestamp: Math.floor(notification.time),
            });

            queryClient.invalidateQueries({ queryKey: ['notifications'] });
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          captureMessage('Stream aborted', { level: 'debug' });
        } else {
          throw error;
        }
      }
    }

    initiateStream();

    return () => {
      ctrl.abort();
    };
  }, [queryClient]);
}
